var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    [
      _vm.inQueue || _vm.failed
        ? _c(
            "md-layout",
            { attrs: { "md-flex": "100", "md-align": "center" } },
            [
              _c("md-theme", { attrs: { "md-name": "blue" } }, [
                _vm.inQueue
                  ? _c(
                      "span",
                      { staticClass: "alert" },
                      [
                        _c("md-icon", {
                          staticClass: "md-warn",
                          attrs: { "md-iconset": "fa fa-exclamation-circle" }
                        }),
                        _vm._v(
                          "This content is in queue for encoding. Please check back soon."
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.failed
                  ? _c(
                      "span",
                      { staticClass: "alert" },
                      [
                        _c("md-icon", {
                          staticClass: "md-warn",
                          attrs: { "md-iconset": "fa fa-exclamation-triangle" }
                        }),
                        _vm._v("This content failed to encode.")
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        : _c(
            "md-layout",
            { staticClass: "containerPreview" },
            [
              _c(
                "md-layout",
                { staticClass: "video-preview", attrs: { "md-flex": "100" } },
                [_c("div", { staticClass: "md-headline" }, [_vm._v("Preview")])]
              ),
              _c(
                "md-layout",
                { attrs: { "md-gutter": 24, "md-flex": "100" } },
                [
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "50", "md-flex-small": "100" } },
                    [
                      _vm.videoSource !== ""
                        ? _c("video", { attrs: { controls: "controls" } }, [
                            _c("source", {
                              attrs: {
                                src: _vm.videoSource,
                                type: _vm.getVideoType(_vm.mediaItem),
                                poster: _vm.getVideoPoster(_vm.mediaItem)
                              }
                            })
                          ])
                        : _vm._e(),
                      _c(
                        "md-layout",
                        { attrs: { "md-flex": "100" } },
                        [
                          _c(
                            "md-layout",
                            {
                              staticClass: "md-caption title",
                              attrs: { "md-flex": "100" }
                            },
                            [
                              _c("div", [_vm._v(_vm._s(_vm.mediaItem.name))]),
                              _c(
                                "div",
                                { staticClass: "md-caption subtitle" },
                                [_vm._v(_vm._s(_vm.mediaItem.name))]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "50", "md-flex-small": "100" } },
                    [
                      _c(
                        "md-layout",
                        { attrs: { "md-column": "md-column" } },
                        [
                          _c("div", { staticClass: "md-subheading" }, [
                            _vm._v("Encoded Versions")
                          ]),
                          _c(
                            "md-list",
                            { staticClass: "full-width md-triple-line" },
                            _vm._l(_vm.mediaItem.renditions, function(
                              rendition,
                              renditionKey
                            ) {
                              return rendition.length > 0
                                ? _c(
                                    "md-list-item",
                                    { key: renditionKey },
                                    [
                                      _c(
                                        "md-avatar",
                                        [
                                          _c("md-image", {
                                            attrs: {
                                              "md-src": _vm.mediaItem.poster[
                                                renditionKey
                                              ].startsWith("http")
                                                ? _vm.mediaItem.poster[
                                                    renditionKey
                                                  ]
                                                : "//" +
                                                  _vm.imageBucketName +
                                                  "/" +
                                                  _vm.mediaItem.poster[
                                                    renditionKey
                                                  ]
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "md-list-text-container"
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(renditionKey))
                                          ]),
                                          _c("span", [
                                            _vm._v(_vm._s(rendition[0].type))
                                          ]),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(rendition[0].width) +
                                                "x" +
                                                _vm._s(rendition[0].height)
                                            )
                                          ])
                                        ]
                                      ),
                                      _c("md-divider", {
                                        staticClass: "md-inset"
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.mediaItem.thumbnails
                ? _c(
                    "md-layout",
                    { attrs: { id: "thumbnails", "md-flex": "100" } },
                    [
                      _c("div", { staticClass: "md-subheading thumbnails" }, [
                        _vm._v("Thumbnails")
                      ]),
                      _vm._l(_vm.mediaItem.thumbnails.default, function(
                        thumbnail
                      ) {
                        return _c("div", [
                          _c("img", {
                            staticClass: "thumbnail",
                            attrs: {
                              src: thumbnail.startsWith("http")
                                ? thumbnail
                                : "//" + _vm.imageServerBase + "/" + thumbnail
                            }
                          })
                        ])
                      })
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65693353", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65693353","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/mediaItem/MediaItemPreview.vue
// module id = 943
// module chunks = 0